module.exports = __webpack_public_path__ + "static/calendario-0fa31e851056d0c9078927a380e026fa.png";